import { PropertyDataPersonalEffects } from "./components";


export const StepTwo = () => <PropertyDataPersonalEffects />
